export interface AddMeeting {
  meeting_title: string;
  meeting_date: string | Date;
  meeting_time: string;
  meeting_timeZone: string;
  meeting_recurring: string;
  zoom_meeting_check: string;
  zoom_link: string;
  meeting_priority: string;
  users_ids: MeetingUserDetail[];
  client_ids: MeetingClientDetail[];
  group_ids: MeetingGroupDetail[];
  userFullname: string;
}

export interface MeetingGroupDetail {
  group_id: string;
  group_name: string;
}

export interface MeetingList {
  createdOn: Date | string;
  meeeing_date: Date | string;
  meeeing_priority: string;
  meeeing_recurring: string;
  meeeing_time: string;
  meeeing_timeZone: string;
  meeeing_title: string;
  meeting_id: string;
  meeting_status: string;
  user_id: string;
  zoom_link: string;
  zoom_meeting: string;
  status: string;
}

export interface MeetingDetail {
  clientDetails: MeetingClientDetail[];
  groupDetails: MeetingGroupDetail[];
  createdBy: string;
  createdOn: Date | string;
  first_name: string;
  last_name: string;
  meeeing_date: Date | string;
  meeeing_priority: string;
  meeeing_recurring: string;
  meeeing_time: string;
  meeeing_timeZone: string;
  meeeing_title: string;
  meeting_id: string;
  meeting_status: string;
  userDetails: MeetingUserDetail[];
  user_email: string;
  zoom_link: string;
  zoom_meeting: string;
  allusers: string;
  meeting_status_new: string;
}

export interface MeetingUserDetail {
  user_id: string;
  first_name: string;
  last_name: string;
  user_emailid: string;
  user_fullname: string;
  meeting_status: string;
  cancel_reason?: string;
  reschedule_date?: string | Date;
  reschedule_time?: string;
  reschedule_timeZone?: string;
}

export interface MeetingClientDetail {
  client_id: string;
  company_emailid: string;
  company_name: string;
}

export interface AcceptMeeting {
  meeting_id: string;
  meeting_status: string;
  meeting_sender_emailid: string;
  meeting_date: string | Date;
  meeting_time: string;
  usr_fullName: string;
}

export interface DeclineMeeting {
  meeting_id: string;
  meeting_status: string;
  meeting_sender_emailid: string;
  meeting_date: string | Date;
  meeting_time: string;
  meeting_decline_Reason: string;
  usr_fullName: string;
}

export interface RescheduleMeeting {
  meeting_id: string;
  meeting_status: string;
  meeting_sender_emailid: string;
  meeting_date: string | Date;
  meeting_time: string;
  meeting_reschedule_date: string | Date;
  meeting_reschedule_time: string;
  meeting_reschedule_timezone: string;
  usr_fullName: string;
}

export interface CancelMeeting {
  meeting_id: string;
  meeting_date: string | Date;
  meeting_time: string;
  usr_fullName: string;
  meeting_status: string;
}
